 
    import { Options, Vue  } from "vue-class-component";   
    import {  Prop } from 'vue-property-decorator';   
    import   SiteUtils   from '@/assets/ts/aplicacao/site';  
	import { namespace } from 'vuex-class';  
    const authStore = namespace('auth'); 
    import { User } from "@/store/modules/AuthModule";
    
    @Options({
        name: "IndexModelTable",
        components: {    },   
    }) 
    export default class IndexModelTable extends Vue {
        
        @authStore.Getter
		public currentUser!: User 
 
        @authStore.Getter
		public token!: any

        @Prop( ) readonly modal_cadastro!: any 
        @Prop( ) readonly perfis!: any 

        public processando = false; 
        public reloadDatatable = false ;
        public config: any = null; 
        public service: any = null;   
        public modelo: any  = null ;  
        public dados: any  = null ;  
        public modal_atualizar: any = null;  

        get hasPermissao( ): boolean {
            return false;
        }

        public modeloAlterado(newVal: string) { 
			this.reloadDatatable = !this.reloadDatatable; 
			this.dados = null ;
			this.modelo = null ;   
		} 
        
        protected excluirModelo( id  ) {  
            SiteUtils.alertConfimacao('Confirma a Exclusão ','' , 
                () => {  
                    this.processando = true;  
                    setTimeout(() => {
                            this.service.excluir( id )
                        .then(response => {     
                            this.reloadDatatable = !this.reloadDatatable;
                            SiteUtils.toastSucesso('Exclusao realizada com sucesso!!' ); 
                            this.processando = false;
                        })
                        .catch(error => { 
                            this.processando = false; 
                            SiteUtils.toastErro('Não foi possivel Excluir ' , error.data.message); 
                        });  
                    }, 10); 
                }
            );  
        }  

        created(){  
            this.config = {  ajax: {} , columns: [] , columnDefs: [] , order: [] };  
        } 

        pushColunaAcoes(){ 
            this.config.columns.push({ data: 'id', name: 'id'  , orderable: false, searchable: false , class: 'text-center' });
        }  
    } 
